var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('div',{staticClass:"flex-column sensitivity"},[_c('VersionAlert',{staticClass:"mb-4"}),_vm._v(" "),_c('SensitivityAnalysis')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }